import StandardItem from './StandardItem';
import type { BranchParkingConfig } from '@/services/dto/parking';
import { formatAmount } from '@/utils/parking';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

interface PurchaseAmountDiscountContentProps {
    pchAmtDcStdList?: BranchParkingConfig['pchAmtDcStdList'];
}

export default function PurchaseAmountDiscountContent({ pchAmtDcStdList }: PurchaseAmountDiscountContentProps) {
    const { t } = useTranslation();

    if (!pchAmtDcStdList || pchAmtDcStdList.length === 0) {
        return null;
    }

    return (
        <div className={clsx('max-h-[calc(34*4*var(--vh-unit))]', pchAmtDcStdList.length > 4 ? 'scrollbar-custom-gray-99938f scrollbar-w-4 overflow-y-auto' : 'overflow-y-hidden')}>
            <div className={clsx('space-y-[calc(8*var(--vh-unit))]')}>
                {pchAmtDcStdList.map((discount) => (
                    <StandardItem
                        key={discount.pafeeInfoSeqno}
                        label={formatAmount(discount.pchAmt)}
                        value={discount.dcTm}
                        labelSuffix={t('parking.unit.won')}
                    />
                ))}
            </div>
        </div>
    );
}
